var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{loaded: _vm.loaded},attrs:{"id":"app"}},[(_vm.loaded)?[(!_vm.game)?void 0:_c('GameVue',{attrs:{"game":_vm.game}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }